import React from "react";
import { RouterProvider } from "react-router-dom";
import { useAppRouter } from "./AppRouter";

const Index = () => {
  const router = useAppRouter();
  return <RouterProvider router={router} />;
};

export default Index;
